"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _SalesforceCampaignsAPI = require("reference-resolvers/api/SalesforceCampaignsAPI");

var _default = (0, _createBatchedReferenceResolver.default)({
  cacheKey: _CacheKeys.default.SALESFORCE_CAMPAIGN_LISTS,
  fetchByIds: _SalesforceCampaignsAPI.getSalesforceCampaignsListById
});

exports.default = _default;
module.exports = exports.default;